import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'vehicle-loader',
  templateUrl: './vehicle-loader.component.html',
  styleUrl: './vehicle-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleLoaderComponent implements OnInit {
  @Input() vehiclePlate: boolean;
  @Input() vehicleDetails: boolean;
  @Input() header_title = 'vehicle database';

  options: AnimationOptions = {
    path: '../../../../../../../../assets/lottie/live-data-feeds.json',
  };

  constructor() {}

  ngOnInit(): void {}
}
